import getStore from "@utils/redux/store";
import { UserDataState } from "@utils/redux/slices/userData";
import { getDayDelta, toISO } from "@utils/datetime";
import { RecommendedPlanState } from "@utils/redux/slices/recommendedPlan";
import { getNoomPlanDurationFromID } from "@utils/plans";

type LeadTrackingProperties = {
  leadCaptureTime?: string;
  leadCaptureSinceDays?: number;
  forcedNoomPlanId?: string;
  forcedPlanDuration?: number;
};

function leadCapture(userData?: UserDataState) {
  const { leadCaptureDateISO } = userData || {};
  if (!leadCaptureDateISO) {
    return {};
  }

  return {
    leadCaptureTime: toISO(leadCaptureDateISO),
    leadCaptureSinceDays: getDayDelta(new Date(leadCaptureDateISO), new Date()),
  };
}

function forcedPlanProperties(recommendedPlan?: RecommendedPlanState) {
  if (!recommendedPlan || !recommendedPlan.isForcedPlan) {
    return {};
  }
  return {
    forcedNoomPlanId: recommendedPlan.noom_plan_id,
    forcedPlanDuration:
      recommendedPlan.billing_cycle_in_months ||
      getNoomPlanDurationFromID(recommendedPlan.noom_plan_id),
  };
}

export function getLeadTrackingProperties(): LeadTrackingProperties {
  let userData;
  let recommendedPlan;

  // Make sure we don't fail if this is called before redux is init.
  try {
    ({ userData, recommendedPlan } = getStore().getState());
  } catch (e) {
    /* NOP */
  }

  return {
    ...leadCapture(userData),
    ...forcedPlanProperties(recommendedPlan),
  };
}
